<template>
  <!-- Preloader -->
  <div v-if="show"
        class="custom-preloader justify-content-center align-items-center">
        <img
          class="animation__shake"
          src="@/assets/loading-36.gif"
          alt="AdminLTELogo"
          height="60"
          width="60"
        />
      </div>
 
</template>

<script>
export default {
  name: 'ThePreLoader',
  data() {
    return {
      show: true
    }
  },
  mounted() {
    if ((this.show)) this.showToggle()
  },
  methods: {
    showToggle() {
      setTimeout(() => {
        this.show = false
      }, 1000);
      //this.$router.push("/dashboard")
    }
    
  }
}
</script>

<style>
 .custom-preloader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 9999;
}
/*
.logo {
    width: 12.5rem;
		height: 12.5rem;
		background: '../assets/loading-36.gif';
		background-repeat: no-repeat;
  }

p {
  font: 600 1.5rem;
  margin-top: 1rem;
}

.circles {
  display: flex;
  margin-top: 1rem;
}

.circles>circle {
  width: 1.5rem;
  height: 1.5rem;
  margin: .75rem;
  background-color: transparent;
  border-radius: 50%;
  animation-name: scaleIn;
  animation-duration: .7s;
  transform: scale(0);
}

:nth-child(1) {
  animation-delay: 0s;
}

:nth-child(2) {
  animation-delay: .05s;
}

:nth-child(3) {
  animation-delay: .1s;
}

:nth-child(4) {
  animation-delay: .15s;
}

:nth-child(5) {
  animation-delay: .2s;
} */
</style>